module.exports = __webpack_public_path__ + "static/media/class_small_warlock.02204f8b.png";